// export const required = value => (!value && value != 0) ? 'Required' : undefined
export const required = (values) => {
  let value;
  if (typeof values === "string") {
    value = values && values.trim();
  } else {
    value = values;
  }
  return (!value && value != 0) || value == "" ? "Required" : undefined;
};

export const maxLength = (max) => (value) => {
  return value && value.length > max
    ? `Must be ${max} characters or less`
    : undefined;
};

export const maxValue = (max) => (value) => {
  return value && parseInt(value) > max
    ? `Must be less then ${max}`
    : undefined;
};

export const minValue = (min) => (value) => {
  return value && parseInt(value) < min ? `Must be at least ${min}` : undefined;
};

export const minLength = (min) => (value) => {
  return value && value.length < min
    ? `Must be ${min} characters or more`
    : undefined;
};

export const number = (value) => {
  return value && isNaN(Number(value)) ? "Must be a number" : undefined;
};
export const positiveNumber = (value) => {
  return value && (isNaN(Number(value)) || Number(value) <= 0)
    ? "Must be a positive number"
    : undefined;
};
export const numberOnly = (value) =>
  value && !/^[0-9]*$/.test(value) ? "Whole number only" : undefined;

export const whiteSpace = (value) =>
  value && /\s/.test(value) ? "No Space allowed" : undefined;

export const alphaBetsOnly = (value) =>
  value && !/^[A-Z a-z.]+$/.test(value)
    ? "Alphabet characters Only"
    : undefined;

export const alphaNumericOnly = (value) =>
  value && !/^[a-zA-Z0-9]*$/.test(value) ? "Alpha Numeric Only" : undefined;

export const alphaNumericOnlyWithSpace = (value) =>
  value && !/^[a-zA-Z0-9 ]*$/.test(value) ? "Alpha Numeric Only" : undefined;

export const emailRegex = (value) =>
  value &&
  !/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,})$/.test(value)
    ? "Invalid email address"
    : undefined;

export const phoneNumberRegex = (value) =>
  value && !/^[6789]\d{9}$/.test(value) ? "Invalid mobile number" : undefined;

export const pincodeRegex = (value) =>
  value && !/^[1-9][0-9]{5}$/.test(value) ? "Invalid Pincode" : undefined;

export const passwordRegex = (value) =>
  value && !/^(?=.*[A-Za-z])[A-Za-z\d\.\#\@\*\%\_\!\@]{8,}$/.test(value)
    ? "Invalid Password (ex: abc12A343#.*%!@, min 8 char)"
    : undefined;

export const alphaNumericOnlyWithSpecialChar = (value) =>
  value && !/^[ A-Za-z][ A-Za-z0-9_@./!@#$%^&*()]*$/.test(value)
    ? "Invalid Text (ex:Name@123$)"
    : undefined;

export const OTPSixDigit = (value) =>
  value && !/^[0-9]{6}$/.test(value)
    ? "OTP must contain six digits"
    : undefined;

export const alphaNumericWithSpacialChr = (value) =>
  value && !/^[a-z0-9A-Z!@.#*()+_ -]*$/.test(value)
    ? "Invalid Name"
    : undefined;

export const spaceSpecialCharNotAllowedExceptHyphen = (value) =>
  value && !/^[a-zA-Z0-9-]*$/.test(value)
    ? "Space & Special Char Not Allowed Except (-)"
    : undefined;

export const DateValidate = (value) => {
  var dateStr = value;
  if (dateStr) {
    var datePat = /^(\d{2,2})-(\d{2,2})-(\d{4}|\d{4})$/;
    var matchDatePattern = dateStr.match(datePat);

    if (matchDatePattern == null) {
      return "Date must be in DD-MM-YYYY format";
    }

    var day = matchDatePattern[1];
    var month = matchDatePattern[2];
    var year = matchDatePattern[3];

    if (day < 1 || day > 31) {
      return "Day must be between 1 and 31";
    }
    if (month < 1 || month > 12) {
      return "Month must be between 1 and 12";
    }
    if ((month == 4 || month == 6 || month == 9 || month == 11) && day == 31) {
      return "Month " + month + " doesn't have 31 days!";
    }
    if (month == 2) {
      var isleap = year % 4 == 0 && (year % 100 != 0 || year % 400 == 0);
      if (day > 29 || (day == 29 && !isleap)) {
        return "February " + year + " doesn't have " + day + " days!";
      }
    }
  }
  return undefined;
};

export const numberZeroToHundredOnly = (value) =>
  value && !/^(0|[1-9][0-9]?|100)$/.test(value)
    ? "Number 0 - 100 only"
    : undefined;

export const alphaNumericAndlimitedSpacialChr = (value) =>
  value && !/^[a-z0-9A-Z!@.#*()+_ -&/]*$/.test(value)
    ? "Invalid Name(Ex: abc12A343 &()-/ )"
    : undefined;

export const uniqueName = (obj, key, name, id) => {
  let error = false;
  for (let o of obj) {
    if (o[key] === name && o.id !== id) {
      error = true;
      break;
    }
  }
  return error ? "Already Taken" : undefined;
};

export const floatNumberOnly = (value) =>
  value && !/^[+-]?\d+(\.\d+)?$/.test(value) ? "Float number only" : undefined;

export const positiveFloatNumberOnly = (value) =>
  value && !/^[0-9]*(?:\.[0-9]*)?$/.test(value)
    ? "Positive Float number only"
    : undefined;

export const positiveFloatNumberOnlyGreaterThanZero = (value) =>
  value && !/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(value)
    ? 'Positive Float number greater than "0" only'
    : undefined;

export const maxCharactersOnly = (value) =>
  value && !/^.{1,30}$/.test(value)
    ? "Must be 30 characters or less"
    : undefined;

export const urlRegex = (value) =>
  value &&
  !/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(
    value
  )
    ? "Invalid url"
    : undefined;

export const ImageValidation = ({ minHeight, minWidth, maxSize, file }) => {
  const { type, size } = file;

  // Check file type (image)
  if (!type?.startsWith("image/")) {
    return "Please upload an image file.";
  }

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const image = new Image();
      image.src = e.target.result;
      image.onload = () => {
        let errr = null;
        if (image.width < minWidth || image.height < minHeight) {
          errr = `Image dimensions should be at least ${minWidth}x${minHeight}.`;
        } else if (size > maxSize) {
          errr = "File size should be up to 1 MB.";
        }
        resolve(errr);
      };
    };
    reader.readAsDataURL(file);
  });

};
